<header class="header-page row">
  <h1 class="col-sm-12 col-md-7 col-xl-7 px-0 header__page__content__title">
    Solicitação de Benefício
  </h1>
  <div class="col-sm-12 col-md-5 col-xl-5 px-1 px-1">
    <a type="button" [routerLink]="['/minhas-solicitacoes-beneficio']"
      class="btn btn-outline-primary col-xl-5 col-lg-6 col-md-5 col-sm-12 px-0 float-right">
      <span>Minhas Solicitações</span>
    </a>
  </div>
</header>
<main class="col-sm-12 col-xl-12 main__content">
  <!-- <section class="content__header d-flex">
      <h2 class="col-7 px-0">
          Solicite o Benefício
      </h2>
    </section> -->
  <ng-template #naoPossuiBeneficios>
    <aviso [textoAviso]="'Você já solicitou todos os benefícios devidos!'">
    </aviso>
  </ng-template>
  <form class="mt-1" [formGroup]="form" (ngSubmit)="solicitarBeneficio()"
    *ngIf="tipos && tipos.length > 0 else naoPossuiBeneficios">
    <div>
      <mat-stepper orientation="vertical" [linear]="true" [stepControl]="form" #stepper [@fadeIn]>
        <mat-step [stepControl]="form.get('titularId')?.value" label="Selecione um Titular"
          errorMessage="Campo titular é obrigatório!" [completed]="true" [optional]="false">
          <div class="col-sm-12 col-md-9 col-lg-6 col-xl-5 p-2">
            <label class="label-form">
              Titular
              <span class="label__form__required">*</span>
            </label>
            <ng-select [items]="titulares" bindLabel="nome" bindValue="cpf_Dependente" formControlName="titularId"
              placeholder="Selecione um Titular" (open)="onSelectOpened()">
            </ng-select>
            <small class="form-text text-muted danger "
              *ngIf="form.get('titularId')?.touched && form.get('titularId')?.invalid">
              Por favor, selecione o Titular
            </small>
          </div>
          <div class="col-12">
            <button type="button" class="col-xl-2 col-lg-3 col-md-4 col-sm-12 btn btn-primary float-right mt-4"
              [disabled]="this.loading || form.get('titularId')?.value == null" matStepperNext>
              Próximo
            </button>
          </div>
        </mat-step>
        <mat-step label="Escolha um Benefício" [optional]="false" [disabled]="true"
          errorMessage="Tipo de benefício é obrigatório." [@fadeIn]>
          <div class="col-sm-12 col-md-9 col-lg-6 col-xl-5 p-2 mt-1" *ngIf="!form.get('titularId')?.invalid">
            <label class="label-form">
              Tipo de Benefício
              <span class="label__form__required">*</span>
            </label>
            <ng-select [items]="tipos" bindLabel="description" bindValue="id" formControlName="benefityTypeId"
              placeholder="Selecione um Benefício" (close)="onSelectClose()">
            </ng-select>
            <small class="form-text text-muted danger "
              *ngIf="form.get('benefityTypeId')?.touched && form.get('benefityTypeId')?.invalid">
              Por favor, selecione ao menos um Benefício
            </small>
          </div>
          <section class="col-12 p-0">
            <section class="col-12 p-0 contentBeneficio"
              *ngIf="this.form.get('benefityTypeId')?.value && this.form.get('benefityTypeId')?.value == 1 && this.form.get('titularId')?.value">
              <h3 class="subtitle mb-2">Descrição do Benefício</h3>
              <section [@fadeIn]>
                <h4>
                  Aposentadoria Programada
                </h4>
                <ol>
                  <li>
                    Benefício com renda mensal vitalicia aos participantes que cumprem os requisitos abaixo.
                  </li>
                </ol>
                <h4>Participantes do Plano III</h4>
                <ol>
                  <p class="subtitle-content">Para fazer jus à solicitação de benefício de aposentadoria programada, o
                    participante deverá:</p>
                  <li>Contar com pelo menos 45 (quarenta e cinco) anos de idade;</li>
                  <li>Ter no mínimo 05 (cinco) anos de filiação ao plano;</li>
                  <li>Ter rescindido o vínculo empregatício com a patrocinadora;</li>
                  <li>O valor inicial do benefício atingir 2 (duas) Ups, ou seja R${{benefitBase.socialSecurityUnit * 2
                    | number:'1.2-2'}};</li>
                </ol>
                <h4>Participantes do Plano Unificado</h4>
                <ol>
                  <p class="subtitle-content">Para fazer jus à solicitação de benefício de aposentadoria programada, o
                    participante deverá:</p>
                  <li>Estar aposentado pelo INSS;</li>
                  <li>Ter rescindido o vínculo empregatício com a patrocinadora;</li>
                </ol>
              </section>
              <h3 class="subtitle mt-2" [@fadeIn]>Documentos Necessários</h3>
              <section [@fadeIn]>
                <h4>São necessários os seguintes documentos para a solicitação de ambos os benefícios:</h4>
                <ol>
                  <li>
                    RG e CPF / Carteira de Motorista;
                  </li>
                  <li>
                    Rescisão de contrato de trabalho ou carteira profissional com data de demissão da
                    patrocinadora;
                  </li>
                  <li>
                    Carta de concessão do INSS é obrigatória para participantes do Plano Unificado;
                  </li>
                  <li>
                    Para quem possui o BSA, comprovação do tempo de serviço declarado na migração de plano
                    em 10/1998,
                    feito por meio de carteiras de trabalho (cópia da foto, qualificação civil e contratos de trabalho),
                    carta de concessão da aposentadoria do INSS com memória de cálculo, declarações de serviço exemplo:
                    polícia
                    reservista, comprovante de pagamento como autônomo e etc;
                    <br>
                    <b>Importante: caso falte alguma comprovação de tempo de serviço quanto ao BSA, o benefício poderá
                      ser
                      reduzido.</b>
                  </li>
                </ol>
              </section>
              <section [@fadeIn]>
                <h4>Carregue aqui seus documentos</h4>
                <ol>
                  <li>RG e CPF / Carteira de Motorista;</li>
                  <li>Rescisão de Contrato: </li>
                  <li>Cartão do INSS e Comprovante do BSA: </li>
                </ol>
              </section>
              <section class="col-xl-4 p-0" [@fadeIn]>
                <form-input [labelInput]="'Carregue aqui seus documentos'" [isRequired]="true" [tipoDocumento]="'rg'"
                  [formFiles]="form.get('files.files')?.value" (adicionar)="adicionarDocumento($event)">
                </form-input>
              </section>
            </section>
            <section class="col-12 p-0 contentBeneficio"
              *ngIf="this.form.get('benefityTypeId')?.value && this.form.get('benefityTypeId')?.value  == 2 && this.form.get('titularId')?.value">
              <div>
                <h3 class="subtitle">Aposentadoria por Invalidez</h3>
              </div>
              <section>
                <ol>
                  <li>
                    Benefício com renda mensal vitalicia aos participantes aposentado por invalidez pela previdência
                    oficial.
                  </li>
                  <br>
                  <li>
                    <b>Participantes do Plano III E do Plano Unificado</b>
                  </li>
                  <p class="subtitle-content">
                    Para fazer jus à solicitação de benefício de aposentadoria por invalidez, o participante deverá:
                  </p>
                  <li>
                    Estar aposentado por invalidez pelo INSS;
                  </li>
                </ol>
              </section>
              <h3 class="subtitle mt-2">Documentos Necessários</h3>
              <section class="mt-1">
                <h4>São necessários os seguintes documentos para a solicitação de ambos os benefícios:</h4>
                <ol>
                  <li>RG e CPF / Carteira de Motorista;</li>
                  <li>Para quem possui o BSA, comprovação do tempo de serviço declarado na migração de plano
                    em 10/1998,
                    feito por meio de carteiras de trabalho (cópia da foto, qualificação civil e contratos de trabalho),
                    carta de concessão da aposentadoria do INSS com memória de cálculo, declarações de serviço exemplo:
                    polícia
                    reservista, comprovante de pagamento como autônomo e etc;
                    <br>
                    <b>Importante: caso falte alguma comprovação de tempo de serviço quanto ao BSA, o benefício poderá
                      ser
                      reduzido.</b>
                  </li>
                  <li>Carta de concessão do INSS por invalidez;</li>
                  <li>Carta de concessão do INSS do auxílio doença;</li>
                </ol>
                <h4>Carregue aqui seus documentos</h4>
                <ol>
                  <li>RG e CPF / Carteira de Motorista;</li>
                  <li>Rescisão de Contrato: </li>
                  <li>Cartão do INSS e Comprovante do BSA: </li>
                </ol>
              </section>
              <section class="col-xl-4 p-0">
                <form-input [labelInput]="'Carregue aqui seus documentos'" [isRequired]="true"
                  [tipoDocumento]="'PeculioPrevidenciario'" [formFiles]="form.get('files.files')?.value"
                  (adicionar)="adicionarDocumento($event)">
                </form-input>
              </section>
            </section>
            <section class="col-12 p-0 contentBeneficio"
              *ngIf="this.form.get('benefityTypeId')?.value && this.form.get('benefityTypeId')?.value  == 3 && this.form.get('titularId')?.value">
              <h4>Pensão por Morte</h4>
              <section>
                <ol>
                  <li>
                    Benefício com renda mensal para os dependentes do titular (conforme regulamento do plano).
                  </li>
                </ol>
                <h4>São necessários os seguintes documentos para a solicitação de ambos os benefícios:</h4>
                <ol>
                  <li>Certidão de óbito;</li>
                  <li>RG e CPF do participante falecido e do solicitante;</li>
                  <li>Comprovante de endereço;</li>
                  <li>Cópia da certidão de casamento ou união estável com anotação de óbito;</li>
                  <li>Carta de concessão da pensão pelo INSS (para Pensão por Morte);</li>
                  <li>Para o pecúlio Adicional: Certidão de óbito, certidão de casamento ou união estável com
                    anotação de óbito, cópia do CPF e RG do titular e do cônjuge;</li>
                </ol>
                <h4>Carregue aqui seus documentos</h4>
                <ol>
                  <li>RG e CPF / Carteira de Motorista;</li>
                  <li>Rescisão de Contrato: </li>
                  <li>Cartão do INSS e Comprovante do BSA: </li>
                </ol>
              </section>
              <section class="col-xl-4 p-0">
                <form-input [labelInput]="'Carregue aqui seus documentos'" [isRequired]="true"
                  [tipoDocumento]="'PeculioPrevidenciario'" [formFiles]="form.get('files.files')?.value"
                  (adicionar)="adicionarDocumento($event)">
                </form-input>
              </section>
            </section>
            <section class="col-12 p-0 contentBeneficio"
              *ngIf="this.form.get('benefityTypeId')?.value && this.form.get('benefityTypeId')?.value  == 4 && this.form.get('titularId')?.value">
              <h4>Pecúlio Previdenciário</h4>
              <section>
                <ol>
                  <li>
                    Benefício de pagamento único para os beneficiários do titular (conforme o regulamento do plano).
                  </li>
                </ol>
                <h4>São necessários os seguintes documentos para a solicitação de ambos os benefícios:</h4>
                <ol>
                  <li>Certidão de óbito;</li>
                  <li>RG e CPF do participante falecido e do solicitante;</li>
                  <li>Comprovante de endereço;</li>
                  <li>Cópia da certidão de casamento ou união estável com anotação de óbito;</li>
                  <li>Carta de concessão da pensão pelo INSS (para Pensão por Morte);</li>
                  <li>Para o pecúlio Adicional: Certidão de óbito, certidão de casamento ou união estável com
                    anotação de óbito, cópia do CPF e RG do titular e do cônjuge;</li>
                </ol>
                <h4>Carregue aqui seus documentos</h4>
                <ol>
                  <li>RG e CPF / Carteira de Motorista;</li>
                  <li>Rescisão de Contrato: </li>
                  <li>Cartão do INSS e Comprovante do BSA: </li>
                </ol>
              </section>
              <section class="col-xl-4 p-0">
                <form-input [labelInput]="'Carregue aqui seus documentos'" [isRequired]="true"
                  [tipoDocumento]="'PeculioPrevidenciario'" [formFiles]="form.get('files.files')?.value"
                  (adicionar)="adicionarDocumento($event)">
                </form-input>
              </section>
            </section>
            <section class="col-12 p-0 contentBeneficio"
              *ngIf="this.form.get('benefityTypeId')?.value && this.form.get('benefityTypeId')?.value  == 5 && this.form.get('titularId')?.value">
              <h4>Plano pecúlio</h4>
              <section>
                <ol>
                  <li>
                    Benefício opcional de pagamento único aos beneficiários indicados pelo titular.
                  </li>
                </ol>
                <h4>São necessários os seguintes documentos para a solicitação de ambos os benefícios:</h4>
                <ol>
                  <li>Certidão de óbito;</li>
                  <li>RG e CPF do participante falecido e do solicitante;</li>
                  <li>Comprovante de endereço;</li>
                </ol>
                <h4>Carregue aqui seus documentos</h4>
                <ol>
                  <li>Certidão de óbito: </li>
                  <li>RG e CPF / Carteira de Motorista;</li>
                </ol>
              </section>
              <section class="col-xl-4 p-0">
                <form-input [labelInput]="'Carregue aqui seus documentos'" [isRequired]="true"
                  [tipoDocumento]="'planoPeculio'" [formFiles]="form.get('files.files')?.value"
                  (adicionar)="adicionarDocumento($event)">
                </form-input>
              </section>
            </section>
            <section class="col-12 p-0 contentBeneficio"
              *ngIf="this.form.get('benefityTypeId')?.value && this.form.get('benefityTypeId')?.value  == 6 && this.form.get('titularId')?.value">
              <section>
                <h4>Adiantamento do Plano Pecúlio</h4>
                <ol>
                  <li>
                    Benefício opcional, que prevê a antecipação da indenização devida ao titular conforme definido no
                    regulamento.
                  </li>
                </ol>
                <h4>São necessários os seguintes documentos para a solicitação de ambos os benefícios:</h4>
                <ol>
                  <li>RG e CPF / Carteira de Motorista;</li>
                  <li>Atestados e laudos de exames (comprovando a invalidez);</li>
                  <!-- <li><b>III</b> - Comprovante de endereço;</li> -->
                </ol>
                <h4>Carregue aqui seus documentos</h4>
                <ol>
                  <li>RG e CPF / Carteira de Motorista;</li>
                  <li>Atestados e laudos de exames (comprovando a invalidez);</li>
                </ol>
              </section>
              <section class="col-xl-4 p-0">
                <form-input [labelInput]="'Carregue aqui seus documentos'" [isRequired]="true"
                  [tipoDocumento]="'adiantamentoPlanoPeculio'" [formFiles]="form.get('files.files')?.value"
                  (adicionar)="adicionarDocumento($event)">
                </form-input>
              </section>
            </section>
            <section class="col-12 content-form-lista">
              <div class="lista-row" *ngFor="let itemFile of this.form.get('files.files')?.value; let i = index">
                <span>
                  {{itemFile.fileName}} - ({{itemFile.size | number: "1.0-2" }} KB)
                </span>
                <div class="lista-actions">
                  <fa-icon class="card__header__icon lista-btn-close" size="2x"
                    (click)="removeFile('documentoPessoaFisicaFiles',i)" [icon]="faSquareXmark"></fa-icon>
                </div>
              </div>
            </section>
          </section>
          <div class="col-12">
            <button type="button" class="col-xl-2 col-lg-3 col-md-4 col-sm-12 btn btn-primary float-right mt-4 ml-1"
              [disabled]="this.loading || form.get('files.files')?.value == null" matStepperNext>
              Próximo
            </button>
            <button type="button" class="col-xl-2 col-lg-3 col-md-4 col-sm-12 btn btn-outline-primary float-right mt-4"
              matStepperPrevious>
              Voltar
            </button>
          </div>
        </mat-step>
        <mat-step label="Revisão do Beneficio">
          <section class="my-4">
            <h4 class="mx-0 px-0">
              Prezado(a) Sr(a): {{ pessoa?.name }} - Matrícula: {{ pessoa?.matricula }} - CPF: {{ pessoa?.cpf }}
            </h4>
            <p class="mt-2">
              Você está solicitando o benefício: <b>{{tipoAposentadoria}}</b>
              <br>
              O benefício será pago de acordo com os dados bancários abaixo:
            </p>
            <div>
              <section class="col-12 p-0 content-form">
                <div class="col-xl-5 mt-1">
                  <label class="content__form__title__label">
                    Agência
                    <span class="label__form__required">*</span>
                  </label>
                  <input class="form-control" formControlName="agencia" placeholder="Agência" />
                  <small class="form-text text-muted content_formulario__small"
                    *ngIf="form.get('agencia')?.touched && form.get('agencia')?.invalid">
                    O campo agência é obrigatório!
                  </small>
                </div>
                <div class="col-xl-5 mt-1">
                  <label class="content__form__title__label">
                    Código do Banco
                    <span class="label__form__required">*</span>
                  </label>
                  <input class="form-control" formControlName="banco" placeholder="Banco" />
                  <small class="form-text text-muted content_formulario__small"
                    *ngIf="form.get('banco')?.touched && form.get('banco')?.invalid">
                    O campo código do banco é obrigatório!
                  </small>
                </div>
                <div class="col-xl-5 mt-1">
                  <label class="content__form__title__label">
                    Conta
                    <span class="label__form__required">*</span>
                  </label>
                  <input class="form-control" formControlName="conta" placeholder="Conta" />
                  <small class="form-text text-muted content_formulario__small"
                    *ngIf="form.get('conta')?.touched && form.get('conta')?.invalid">
                    O campo conta é obrigatório!
                  </small>
                </div>
                <div class="col-xl-5 mt-1">
                  <label class="content__form__title__label">
                    Tipo da Conta
                    <span class="label__form__required">*</span>
                  </label>
                  <ng-select name="name" bindLabel="name" bindValue="value" placeholder="Selecione um Tipo"
                    formControlName="tipoConta" [items]="this.tiposDeBanco" [clearable]="false">
                  </ng-select>
                  <small class="form-text text-muted content_formulario__small"
                    *ngIf="form.get('tipoConta')?.touched && form.get('tipoConta')?.invalid">
                    O campo tipo da conta é obrigatório!
                  </small>
                </div>
                <!-- <div class="col-12 mx-3 my-2 form-check" >
                    <input class="form-check-input" type="checkbox" formControlName="confirm" id="flexCheckDefaolt" >
                    <label class="form-check-label-orange" for="flexCheckDefaolt">
                      Editar Dados                      
                    </label>
                  </div>  -->
              </section>
              <!-- <section *ngIf="tipoBeneficio != 'Adiantamento do Plano Peculio' "> -->
              <section *ngIf="form.get('benefityTypeId')?.value != 6">
                <p>
                  Selecione abaixo seus dependentes para dedução de imposto de renda:
                </p>
                <section class="mt-2 content-beneficiarios">
                  <!-- <div class="col-12">
                      <div class="form-check" data-toggle="tooltip">
                        <input type="checkbox" class="form-check-input" id="selecionarTodos" (click)="selecionarTodos()"/>                          
                        <label class="form-check-label" for="selecionarTodos">SELECIONAR TODOS</label>
                      </div>
                    </div> -->
                  <div class="mt-2 checkbox-titulares" *ngFor="let titular of dependentes;let i = index">
                    <div class="col-12">
                      <div class="form-check" data-toggle="tooltip">
                        <input type="checkbox" class="form-check-input" [id]="i" (click)="checked(titular,i)">
                        <label [for]="i" class="form-check-label">{{titular.nome}} - {{titular.dependencia}}</label>
                      </div>
                    </div>
                  </div>
                </section>
              </section>
            </div>
            <section class="mt-4">
              <h4>IMPORTANTE!</h4>
              <ol class="mx-2" style="list-style-type: circle;">
                <li *ngIf="form.get('benefityTypeId')?.value != tipoBeneficioEnum.ADIANTAMENTOPLANOPECULIO">Assumo o
                  compromisso de atualizar minhas informações cadastrais quando da ocorrência de qualquer alteração,
                  comunicando imediatamente à Fundação Copel.</li>
                <li *ngIf="form.get('benefityTypeId')?.value != tipoBeneficioEnum.ADIANTAMENTOPLANOPECULIO">A fim de
                  manter a continuidade do benefício solicitado, os aposentados e pensionistas devem responder as
                  campanhas periódicas de prova de vida.</li>
                <li *ngIf="form.get('benefityTypeId')?.value != tipoBeneficioEnum.ADIANTAMENTOPLANOPECULIO">Estou ciente
                  que a análise de pagamento é apenas por meio eletrônico, disponível na área restrita do participante
                  no site da Fundação Copel.</li>
                <li *ngIf="form.get('benefityTypeId')?.value != tipoBeneficioEnum.ADIANTAMENTOPLANOPECULIO">Autorizo a
                  Fundação Copel a descontar, além dos débitos obrigatórios, aqueles eventuais em meu nome do meu
                  benefício, inclusive sobre o abono anual (13º benefício).</li>
                <li *ngIf="form.get('benefityTypeId')?.value != tipoBeneficioEnum.ADIANTAMENTOPLANOPECULIO">A concessão
                  do benefício é condicionada à aprovação de todos os documentos necessários.</li>
                <li *ngIf="form.get('benefityTypeId')?.value != tipoBeneficioEnum.ADIANTAMENTOPLANOPECULIO">Não havendo
                  tempo hábil para a implantação da aposentadoria e pensão por morte no mês de solicitação, o primeiro
                  pagamento ocorrerá no mês seguinte.</li>
                <li *ngIf="form.get('benefityTypeId')?.value == tipoBeneficioEnum.ADIANTAMENTOPLANOPECULIO">A sua
                  solicitação de antecipação será analisada conforme as regras do regulamento do plano pecúlio.</li>
                <li *ngIf="form.get('benefityTypeId')?.value == tipoBeneficioEnum.ADIANTAMENTOPLANOPECULIO">O prazo para
                  analise da sua solicitação é de até <b>30 dias</b>.</li>
                <li>
                  <b>Clicando em “Finalizar”, você formaliza o pedido de benefício, em caráter irretratável, aceita os
                    termos de condições e valida as informações cadastrais.</b>
                </li>
              </ol>
            </section>
            <section class="col-12 mx-2 p-0 my-2">
              <div class="form-check">
                <input class="form-check-input" type="checkbox" formControlName="acceptedTerms" id="flexCheckTerms">
                <label class="form-check-label-orange" for="flexCheckTerms">
                  Aceito os termos de condições e valido as informações cadastradas acima. Solicitação do Benefício
                  sendo realizada no dia {{currentDate}} e
                  Concordo em enviar os documentos solicitados e estou ciente de que o benefício somente será concedido
                  mediante o envio de todos os documentos necessários.
                </label>
              </div>
            </section>
            <div class="col-12 p-0 my-0 content-botao-solicitar">
              <button class="col-xl-2 col-md-3 col-sm-12  btn btn-primary"
                [disabled]="this.loading || form.get('acceptedTerms')?.value == false || form.get('files.files')?.value == null || form.invalid">
                Solicitar
              </button>
            </div>
          </section>
        </mat-step>
      </mat-stepper>
    </div>
    <aviso *ngIf="aposentadoriaPendente && !adiantamentoPendente"
      [textoAviso]="'Você Possui Solicitação de Aposentadoria Pendente!'">
    </aviso>
    <aviso *ngIf="adiantamentoPendente && !aposentadoriaPendente"
      [textoAviso]="'Você Possui Solicitação de adiantamento do plano pecúlio Pendente!'">
    </aviso>
  </form>
</main>
<footer class="col-12 footer__page__content">
</footer>